import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { Provider as ReduxProvider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

import App from './App';
import { store, persistor } from './store';

import 'simplebar/src/simplebar.css';
import 'assets/third-party/apex-chart.css';

// ==============================|| MAIN - REACT DOM RENDER  ||============================== //

const container = document.getElementById('root')!;
const root = createRoot(container);

const afterBootstrap = (init: boolean) => {
    if (init) {
        return (
            <BrowserRouter>
                <App />
            </BrowserRouter>
        );
    }
    return null;
};

root.render(
    <ReduxProvider store={store}>
        <PersistGate loading={null} persistor={persistor}>
            {init => afterBootstrap(init)}
        </PersistGate>
    </ReduxProvider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals(console.log);
